import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';
import { obtenerHorarios } from '../../../services/HorarioTurno/TurnoService';

export const useAdminHorario = () => {
    const [cargaHorario, setCargaHorario] = useState(false);
    const [horario, setHorario] = useState(null);
    const [lstHorario, setLstHorario] = useState([]);

    const [mostrarElimina, setMostrarElimina] = useState(false);
    const [mostrarEdita, setMostrarEdita] = useState(false);
    const [mostrarNuevo, setMostrarNuevo] = useState(false);
    const [refresca, setRefresca] = useState(false);

    useEffect(() => {
        const cargarHorarios = async () => {
            try {
                setCargaHorario(true);
                const datos = await obtenerHorarios();
                setLstHorario(datos);
            } catch (error) {
                console.error(error.message);
            } finally {
                setCargaHorario(false);
            }
        };
        cargarHorarios();
    }, [refresca]);

    const onEdit = (rawData) => {
        setHorario(rawData);
        setMostrarEdita(true);
    };
    const onDelete = (rawData) => {
        setHorario(rawData);
        setMostrarElimina(true);
    };

    const onNuevo = () => {
        setMostrarNuevo(true);
    };

    const accionButtonBody = (dataFila) => {
        return (
            <div className="flex justify-center gap-2">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info" onClick={() => onEdit(dataFila)} tooltip="Editar" />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => onDelete(dataFila)} tooltip="Eliminar" />
            </div>
        );
    };

    const ocultaDialogElimina = () => {
        setMostrarElimina(false);
    };

    const ocultaDialogEdita = () => {
        //console.log ('qq0', 'ingresando')
        setMostrarEdita(false);
    };

    const ocultaDialogNuevo = () => {
        setMostrarNuevo(false);
        // refresca el componente
        setRefresca((preValue) => !preValue);
    };

    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        sigla: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' }
    });

    // Estado para los valores visuales de los filtros
        const [valoresFiltros, setValoresFiltros] = useState({
            booking: '',
            sigla: '',
            nombre: ''
        });
        // Función para limpiar todos los filtros
        const limpiarFiltros = () => {
            setValoresFiltros({
                sigla: '',
                nombre: '',
                global: ''
            });
    
            setFiltros({
                global: { value: null, matchMode: 'contains' },
                sigla: { value: null, matchMode: 'contains' },
                nombre: { value: null, matchMode: 'contains' }
            });
        };
    
        // Filtro para texto
        const textoFilterTemplate = (options, field) => {
            return (
                <InputText
                    value={valoresFiltros[field]}
                    onChange={(e) => {
                        const nuevoValor = e.target.value;
                        // Actualizamos el valor visual
                        setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));
    
                        // Actualizamos el filtro real después de un pequeño delay
                        setTimeout(() => {
                            const newFilters = { ...filtros };
                            newFilters[field].value = nuevoValor;
                            setFiltros(newFilters);
                            options.filterApplyCallback(nuevoValor);
                        }, 10);
                    }}
                    placeholder={`Filtrar por ${field}`}
                    className="w-full"
                />
            );
        };

    return { ocultaDialogElimina, accionButtonBody, ocultaDialogEdita, ocultaDialogNuevo, onNuevo, mostrarEdita, mostrarNuevo, 
        horario, lstHorario, cargaHorario, mostrarElimina, filtros, textoFilterTemplate };
};
